
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logindetail } from "../../context/Logindetail";
import { ExclamationCircle } from "react-bootstrap-icons";
import toast from "react-hot-toast";
import { Delete_account_fun } from "../../api/Controllapi";


const DeleteAccount = () => {
    const navigate = useNavigate();
    const { setdetail_info } = useContext(Logindetail);
    const [loading, setLoading] = useState(false)


    const delete_acc = async () => {
    setLoading(true);
    try {
        const response = await Delete_account_fun();

      
        toast.success(response?.message || "Account deletion request sent successfully!");

       
        document.querySelector("#delete_account_modal [data-bs-dismiss='modal']")?.click();

       
        navigate("/user/dashboard");
    } catch (error) {
        if (error.response) {
            if (error.response.status === 409) {
                toast.error(error.response.data?.message || "Delete request already submitted!");
            } else {
                toast.error(error.response.data?.message || "Failed to delete account. Please try again.");
            }
        } else if (error.request) {
            toast.error("No response from server. Please try again.");
        } else {
            toast.error("Something went wrong while deleting account.");
        }
        console.error("Delete account error:", error);

       
        document.querySelector("#delete_account_modal [data-bs-dismiss='modal']")?.click();
    } finally {
        setLoading(false);
    }
};




    return (
        <>
            <section>
                <div
                    className="modal fade"
                    id="delete_account_modal"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body text-center">
                                <h2 className="logouticon">
                                    <ExclamationCircle />
                                </h2>
                                <h3 className="logout-text">
                                    Are you sure you want to delete your Account?
                                </h3>
                            </div>
                            <div className="modal-footer logout text-center d-block gap-3">


                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    // data-bs-dismiss="modal"
                                    onClick={delete_acc}
                                >
                                    {loading ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            
                                        </>
                                    ) : (
                                        "Yes"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-bs-dismiss="modal"
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default DeleteAccount;
